import { useLocaleDirection } from "@/hooks/useLocaleDirection";
import { MutationCache, QueryCache, QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { DEFAULT_QUERY_STALE_TIME, defaultQueryRetry } from "@/queries/queryUtil";
import { reportToFlare } from "@/lib/flareReport";

export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: DEFAULT_QUERY_STALE_TIME,
            retry: defaultQueryRetry,
            // refetchOnWindowFocus stays at TanStack's default (true): the sidebar balance and
            // the OAuth-return integration screens rely on focus refetch as their only refresh.
            // refetchOnMount: false,
        },
    },
    queryCache: new QueryCache({
        onError: (error, query) => {
            reportToFlare(error, { "query.key": JSON.stringify(query.queryKey) });
        },
    }),
    mutationCache: new MutationCache({
        onError: (error, _variables, _context, mutation) => {
            reportToFlare(error, {
                "mutation.key": JSON.stringify(mutation.options.mutationKey ?? []),
            });
        },
    }),
});

export function LocalQueryClientProvider({ children }: { children: React.ReactNode }) {
    const dir = useLocaleDirection();
    return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>;
}
